/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeRectVIcon32Regular = forwardRef('ShapeRectVIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 7.5A5.5 5.5 0 0 1 10.5 2h11A5.5 5.5 0 0 1 27 7.5v17a5.5 5.5 0 0 1-5.5 5.5h-11A5.5 5.5 0 0 1 5 24.5v-17ZM10.5 4A3.5 3.5 0 0 0 7 7.5v17a3.5 3.5 0 0 0 3.5 3.5h11a3.5 3.5 0 0 0 3.5-3.5v-17A3.5 3.5 0 0 0 21.5 4h-11Z" })));
});
